import { dismissUserNotification } from "../apiClient";
import { isNotificationDismissible } from "./applicantProfileNotification";

/**
 * Mark a notification as viewed when the user opens it (sets dismissed_at when allowed).
 * @returns {Promise<boolean>} true if dismissed successfully
 */
export async function dismissNotificationIfViewed(authToken, role, notification) {
  if (!isNotificationDismissible(notification)) return false;
  const t = String(authToken || "").trim();
  const id = notification?.id;
  if (!t || !id) return false;
  try {
    await dismissUserNotification(t, role, id);
    return true;
  } catch {
    return false;
  }
}
